var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipantsBlueBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1525,
    height: 918,
    viewBox: "0 0 1525 918",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1319 0L-512 920H1009.87L1525 0H3.1319Z",
    fill: "#0099DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantsBlueBg);
export default __webpack_public_path__ + "static/media/participants-blue-bg.6dbdc766bdd0f4f390aab59110bcf307.svg";
export { ForwardRef as ReactComponent };